export const AVISO_NOVA_DATA_PAGAMENTO = 'A partir do próximo mês a cobrança será realizada na nova data'

export const TITULO_REGULARIZAR_PAGAMENTO = 'Aguardando pagamento'

export const TITULO_REGULARIZAR_PAGAMENTO_BOTAO = 'Regularizar pagamento'

export const DESCRICAO_REGULARIZAR_PAGAMENTO = 'O pagamento do mês vigente está em aberto. Clique no botão abaixo para regularizar sua situação.'

export const TITULO_MENSAGEM_BOLETO_PENDENTE = 'Atenção'

export const TITULO_MENSAGEM_PIX_PENDENTE = 'Atenção'

export const EDITAR = 'editar'
